<template>
  <el-dialog
    :title="title"
    :visible.sync="isUpdateHistoryAction"
    width="600px"
    :before-close="handleClose"
    top="10vh"
    :close="handleClose"
    custom-class="modern-dialog"
    @open="handleOpen"
    :close-on-click-modal="false"
  >
    <div class="dialog-header-themed">
      <div class="themed-icon">
        <i :class="checkUpdate ? 'el-icon-edit' : 'el-icon-monitor'"></i>
      </div>
      <div class="themed-text">
        <h3>{{ title }}</h3>
        <p v-if="!checkUpdate">Xem thông tin chi tiết và khóa nhận diện của hoạt động Cloud S3.</p>
        <p v-else>Cập nhật tên, loại, mã khóa và mô tả chi tiết của hoạt động Cloud S3.</p>
      </div>
    </div>

    <el-form
      :model="formData"
      :rules="rules"
      ref="formData"
      label-position="top"
      class="modern-dialog-form"
    >
      <div class="form-section">
        <h4 class="section-divider"><i class="el-icon-info"></i> Thông tin chung</h4>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="Tên hoạt động" prop="nameAction">
              <el-input v-model="formData.nameAction" :disabled="!checkUpdate" placeholder="Nhập tên hoạt động" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Loại tác vụ" prop="typeAction">
              <el-input v-model="formData.typeAction" :disabled="!checkUpdate" placeholder="Loại hoạt động" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Mã hoạt động (Code)" prop="codeAction">
              <el-input v-model="formData.codeAction" disabled placeholder="Mã hoạt động" />
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <div class="form-section">
        <h4 class="section-divider"><i class="el-icon-notebook-2"></i> Mô tả chức năng</h4>
        <el-form-item label="" prop="descriptionAction">
          <el-input
            v-model="formData.descriptionAction"
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 8}"
            :disabled="!checkUpdate"
            placeholder="Mô tả cụ thể tác vụ hoạt động..."
          />
        </el-form-item>
      </div>
    </el-form>

    <template #footer>
      <div class="dialog-footer-themed">
        <el-button type="danger" plain size="medium" icon="el-icon-circle-close" @click="handleClose">
          Đóng
        </el-button>
        <el-button v-if="checkUpdate" type="success" size="medium" icon="el-icon-circle-check" :loading="loading" @click="handleUpload">
          Lưu lại
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import HistoryActionMaster from "@/services/AdminService/HistoryActionMaster";

export default {
  name: "UpdateHistoryActionDialog",
  props: {
    checkUpdate: {
      type: Boolean,
      default: true
    },
    isUpdateHistoryAction: {
      type: Boolean,
      default: false
    },
    idHistory: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      formData: {
        nameAction: "",
        typeAction: "",
        codeAction: "",
        descriptionAction: ""
      },
      loading: false,
      rules: {
        nameAction: [
          { required: true, message: "Không được để trống", trigger: "change" }
        ],
        typeAction: [
          { required: true, message: "Không được để trống", trigger: "change" }
        ],
        codeAction: [
          { required: true, message: "Không được để trống", trigger: "change" }
        ]
      },
      title: ""
    };
  },
  methods: {
    handleOpen() {
      HistoryActionMaster.findHistoryActionAdminById(this.idHistory).then((res) => {
        this.formData = res.data.data || {};
      });
      this.title = this.checkUpdate ? "Sửa hoạt động" : "Chi tiết hoạt động";
    },
    handleClose() {
      this.$refs["formData"].resetFields();
      this.$emit("close");
    },
    handleUpload() {
      this.$refs["formData"].validate((valid) => {
        if (valid) {
          this.loading = true;
          HistoryActionMaster.updateHistoryActionAdmin(this.formData)
            .then((res) => {
              if (res.data) {
                this.$message.success("Sửa hoạt động thành công");
                this.handleClose();
              } else {
                this.$message.error("Sửa hoạt động thất bại");
              }
            })
            .catch((err) => {
              this.$message.error(err.response?.data?.message || "Lỗi cập nhật hoạt động!");
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>

<style lang="scss">
/* Modern styling for dialog headers and layouts */
.modern-dialog {
  border-radius: 14px !important;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15) !important;

  .el-dialog__header {
    display: none; /* Custom header used instead */
  }

  .el-dialog__body {
    padding: 0 !important;
  }
}
</style>

<style lang="scss" scoped>
.dialog-header-themed {
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  padding: 24px 28px;
  display: flex;
  align-items: center;
  gap: 16px;
  color: #fff;

  .themed-icon {
    width: 48px;
    height: 48px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid rgba(255, 255, 255, 0.25);
    font-size: 20px;
  }

  .themed-text {
    h3 {
      margin: 0 0 4px 0;
      font-size: 18px;
      font-weight: 700;
      letter-spacing: 0.5px;
    }
    p {
      margin: 0;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.8);
    }
  }
}

.modern-dialog-form {
  padding: 24px 28px;
}

.form-section {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;

  .section-divider {
    margin: 0 0 16px 0;
    font-size: 13px;
    font-weight: 700;
    color: #3b82f6;
    display: flex;
    align-items: center;
    gap: 6px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid #e2e8f0;
    padding-bottom: 8px;
  }
}

/deep/ .el-form-item {
  margin-bottom: 16px;

  .el-form-item__label {
    font-weight: 600;
    color: #475569;
    padding: 0 0 4px 0 !important;
    font-size: 13px;
  }
  
  .el-input__inner {
    border-radius: 6px;
    border: 1px solid #cbd5e1;
    &:focus {
      border-color: #3b82f6;
    }
  }
  
  .el-input.is-disabled .el-input__inner,
  .el-textarea.is-disabled .el-textarea__inner {
    background-color: #f1f5f9;
    color: #1e293b;
    border-color: #cbd5e1;
    font-weight: 600;
    cursor: default;
  }
}

.dialog-footer-themed {
  padding: 16px 28px;
  background: #f1f5f9;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  border-bottom-left-radius: 14px;
  border-bottom-right-radius: 14px;
}

.w-full {
  width: 100%;
}
</style>